import ReactDOM from "react-dom/client";
import './index.css'
import App from './App'
import {ChakraProvider, ColorModeScript, extendTheme, type StyleFunctionProps} from "@chakra-ui/react";
import colors from "./theme/colors";

const appTheme = extendTheme({
  colors: colors,
  config: {
    initialColorMode: "dark",
    useSystemColorMode: false,
  },
  styles: {
    global: (props: StyleFunctionProps) => ({
      body: {
        bg: props.colorMode === "dark" ? "onyxBlack.900" : "onyxBlack.100",
      },
    }),
  },
  components: {
    Input: {
      variants: {
        unstyled: {
          field: {
            _hover: {
              boxShadow: "none",
              borderColor: "transparent",
            },
            _focus: {
              boxShadow: "none",
              borderColor: "transparent",
            },
            _active: {
              boxShadow: "none",
              borderColor: "transparent",
            },
          },
        },
      },
      defaultProps: {
        variant: "unstyled",
      },
    },
  },
});

localStorage.removeItem('chakra-ui-color-mode')

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <ChakraProvider theme={appTheme}>
    <ColorModeScript initialColorMode={appTheme.config.initialColorMode}/>
    <App/>
  </ChakraProvider>
);